if (!customElements.get('tabbed-text-image-grid')) {
  class TabbedTextImageGrid extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');

      // A section with a single untitled tab renders no tab row, but its one
      // panel still needs its media carousels initialised.
      if (!this.panels.length) return;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activateTab(index));
        tab.addEventListener('keydown', (event) => this.onKeyDown(event, index));
      });

      this.onMobileMediaChange = () => this.syncMediaCarousels();
      this.mobileMediaQuery.addEventListener('change', this.onMobileMediaChange);

      const initialIndex = this.tabs.findIndex(
        (tab) => tab.getAttribute('aria-selected') === 'true'
      );
      this.activateTab(initialIndex >= 0 ? initialIndex : 0);
    }

    disconnectedCallback() {
      this.mobileMediaQuery?.removeEventListener('change', this.onMobileMediaChange);
    }

    activateTab(index) {
      this.tabs.forEach((tab, tabIndex) => {
        const isSelected = tabIndex === index;
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.tabIndex = isSelected ? 0 : -1;
      });

      this.panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== index;
      });

      this.refreshPanelCarousels(this.panels[index]);
    }

    syncMediaCarousels() {
      const activePanel = this.panels.find((panel) => !panel.hidden);
      this.refreshPanelCarousels(activePanel);
    }

    refreshPanelCarousels(panel) {
      if (!panel) return;

      panel
        .querySelectorAll('embla-component.ttig__media-embla--mobile, embla-component.tpu__info-embla')
        .forEach((emblaComponent) => {
          const applyCarouselState = () => {
            if (!emblaComponent.emblaApi) {
              requestAnimationFrame(applyCarouselState);
              return;
            }

            if (emblaComponent.classList.contains('ttig__media-embla--mobile')) {
              const watchDrag = this.mobileMediaQuery.matches
                ? (_emblaApi, event) =>
                    !event.target.closest('.ttig__media-video, .ttig__media-video video, video-delay-loader')
                : false;

              emblaComponent.emblaApi.reInit({ watchDrag });
              return;
            }

            emblaComponent.emblaApi.reInit();
          };

          applyCarouselState();
        });
    }

    onKeyDown(event, currentIndex) {
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        event.preventDefault();
        nextIndex = (currentIndex + 1) % this.tabs.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        event.preventDefault();
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        event.preventDefault();
        nextIndex = 0;
      } else if (event.key === 'End') {
        event.preventDefault();
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      this.activateTab(nextIndex);
      this.tabs[nextIndex].focus();
    }
  }

  customElements.define('tabbed-text-image-grid', TabbedTextImageGrid);
}
